<template>
  <section
    style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    "
  >
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
              <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
              Ajouter un nouveau Recitateur
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="addCard">
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-1">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajouter un nouveau Recitateur</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="RecitateurName"
                    label="Nom"
                    outlined
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-combobox
                    v-model="country"
                    :items="countryList"
                    item-text="name"
                    item-value="name"
                    :filter="filterCountry"
                    label="Pays"
                    placeholder="ex: Koweït / keweit"
                    outlined
                    clearable
                    @change="onCountryChange"
                  >
                    
                  </v-combobox>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="flag"
                    label="Drapeau"
                    placeholder="kw"
                    outlined
                    maxlength="2"
                    clearable
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" v-if="RecitateurName">
                  <vue-upload-multiple-image
                    style="margin-left: 160px"
                    accept="image/*	"
                    v-model="images_BG"
                    :data-images="images_BG"
                    name="images"
                    drag-text="Veuillez ajouter une image Sans arrière-plan"
                    browse-text="Browse image"
                    primary-text="Image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :loading="load"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove_BG"
                    @images-updated="handleImagesUpdated_BG"
                    :idUpload="images_BGId"
                  >
                  </vue-upload-multiple-image>
                  <v-progress-linear
                    v-if="showlowding_BG && uploadPercentage_BG < 100"
                    style="max-width: 190px; margin-left: 160px"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage_BG) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>
              </v-row>
              <!--    <v-col cols="12" sm="12" md="6" style="">
                <v-row align="center">
                  <v-col cols="auto" style="margin-top: 16px;">
                    <span>Premium:</span>
                  </v-col>
                  <v-col cols="auto">
                    <v-switch v-model="model" hide-details inset></v-switch>
                  </v-col>
                  <v-col
                    cols="auto"
                    style="margin-top: 16px; margin-left: -20px;"
                  >
                    <v-icon color="#00a325" v-if="!model">
                      {{ icons.mdiLockOpen }}
                    </v-icon>
                    <v-icon color="primary" v-if="model">
                      {{ icons.mdiLock }}
                    </v-icon>
                  </v-col>
                </v-row>
              </v-col> -->
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="imageId == null"
                      class="info"
                      @click="validate"
                      :loading="isButtonLoading"
                    >
                      {{ isButtonLoading ? "Chargement..." : "Suivant" }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Recitateur</v-card-title>
      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>
      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        :headers="headers"
        :items="RecitateurArray"
        class="elevation-1"
        item-key="id"
      >
        <template v-slot:[`item.imgSansBackgroundUrl`]="{ item }">
          <v-img
            v-if="item.fileUrlDBType != 'svg'"
            :src="item.imgUrl"
            width="65"
            height="65"
          />
          <div
            v-if="item.fileUrlDBType === 'svg'"
            v-html="item.svgContent"
          ></div>

          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.country`]="{ item }">
          <span>{{ item.country || "-" }}</span>
        </template>

        <template v-slot:[`item.isTranslated`]="{ item }">
          <span style="color: #00a325" v-if="item.isTranslated">
            Modification Terminée
          </span>
          <span style="color: #ff0000" v-if="!item.isTranslated">
            La modification est incomplète
          </span>
        </template>

        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditRecitateur(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.recitateurId)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddTheme" max-width="530">
        <v-card class="pa-6 pa-sm-6" max-width="600px">
          <v-card-title style="text-align: center" class="justify-center mb-2"
            >Etes vous sur de vouloir ajouter le Recitateur
          </v-card-title>
          <v-card-subtitle
            class="text-h6 mb-3"
            style="text-align: center; color: #24aeb1"
            >{{ RecitateurName }}
          </v-card-subtitle>
       

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="ajoutRecitateur()"
              :color="loadingbtn ? 'grey' : 'info'"
              :disabled="loadingbtn"
            >
              <span v-if="!loadingbtn">Confirmer</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
            <v-btn
              :color="loadingbtn ? 'grey' : 'error'"
              :disabled="loadingbtn"
              @click="reinitialisationFormulaire()"
            >
              <span v-if="!loadingbtn">Annuler</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteRecitateur" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le Recitateur ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteRecitateur = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteRecitateur()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import store from "../../store/image";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import {
  mdiPlus,
  mdiDeleteOutline,
  mdiPencil,
  mdiDatabasePlusOutline,
  mdiLockOpen,
  mdiLock,
} from "@mdi/js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import Constant from "@/utils/constants";
import { getAllRecitateur } from "@/views/qorani/services/services";
import COUNTRIES from "@/utils/countries";
export default {
  components: { VueUploadMultipleImage },
  data() {
    return {
      search: "",
      uploadPercentage_BG: null,
      fakePercentage_BG: null,
      uploadPercentage: null,
      fakePercentage: null,
      showlowding: false,
      showlowding_BG: false,
      imagesId: "0",
      images_BGId: "1",
      model: false,
      addCard: false,
      loadingbtn: false,
      icons: {
        mdiLockOpen,
        mdiLock,
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
      },

      valid: true,
      RecitateurName: "",
      country: "",
      flag: "",
      countryList: COUNTRIES,
      suratName: "",
      themeDescription: "",
      numVerset: "",
      recitateur: {
        name: "",
        country: "",
        flag: "",
        isTranslated: "",
        fileUrlDBId: "",
      },
      loadingAddJuz: false,
      dialogAddTheme: false,
      RecitateurArray: [],
      isLoadingTables: false,
      headers: [
        { text: "Image", value: "imgSansBackgroundUrl" },
        { text: "Name", value: "name" },
        { text: "Pays", value: "country" },
        { text: "Drapeau", value: "flag", align: "center" },
        { text: "Statut Modification", value: "isTranslated" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      dialogDeleteRecitateur: false,
      dialogConfirmEditTheme: false,
      loadingEditJuz: false,
      images: [],
      images_BG: [],
      load: false,
      imagesUpload: [],
      imagesUpload_BG: [],
      imageUrl: "",
      imageId: null,
      svgContent: "",
      imageUrl_BG: "",
      imageId_BG: "",
      isButtonLoading: false,
      idThemeSupprimmer: "",
      themeEdit: [],
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
    };
  },
  methods: {
    async loadImage(item) {
      if (item.fileUrlDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          item.svgContent = svgContent; // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        item.imgUrl = `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`;
      }
    },

    // async getImageUrl(recitateur) {
    //   if (recitateur.fileUrlDBType == "svg") {
    //     try {
    //       const response = await fetch(
    //         `${Constant.QORANI}fileDB/files/${recitateur.fileUrlDBId}`
    //       );
    //       if (!response.ok) {
    //         console.log("not ok");

    //         throw new Error("Échec du chargement de l'image SVG");
    //       }

    //       this.svgContent = await response.text();
    //       return;
    //     } catch (error) {
    //       console.error("Erreur lors du chargement de l'image :", error);
    //     }
    //   } else {
    //     console.log(`${Constant.QORANI}fileDB/files/${recitateur.fileUrlDBId}`);

    //     return `${Constant.QORANI}fileDB/files/${recitateur.fileUrlDBId}`;
    //   }
    // },
    redirectToEditRecitateur(item) {
      this.$router.push({
        name: "EditRecitateur",
        params: { id: item.recitateurId, item: item },
      });
    },
    suppressionAction(item) {
      this.idThemeSupprimmer = item;
      // this.dialogDeleteRecitateur = true;
      this.deleteRecitateur();
    },
    async deleteRecitateur() {
      const responseCategorie = await fetch(
        Constant.QORANI + `recitateur/delete/${this.idThemeSupprimmer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteRecitateur = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteRecitateur = false;
      }
    },
    async ajoutRecitateur() {
      // const imageId = store.state.imageId;

      this.recitateur.name = this.RecitateurName;
      this.recitateur.country = this.country ? this.country.trim() : "";
      this.recitateur.flag = this.flag ? this.flag.trim() : "";
      // this.recitateur.isTranslated = this.model;
      // this.recitateur.imgUrlId = this.imageId;
      // this.recitateur.imgSansBackgroundUrlId = this.imageId_BG;
      // this.recitateur.fileUrlDBId = imageId;

      const responseCategorie = await fetch(
        Constant.QORANI + "recitateur/add",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.recitateur),
        }
      );

      try {
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du theme, veuillez réessayez plus tard, Merci."
        );
      }
    },
    filterCountry(item, queryText) {
      if (!queryText) return true;
      const query = queryText;
      return (
        item.name.includes(query) ||
        item.code.includes(query)
      );
    },
    onCountryChange(val) {
      if (!val) {
        this.country = "";
        return;
      }
        this.country = val.name;
          this.flag = val.code;
      
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.dialogAddTheme = true;
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddTheme = false;
      this.RecitateurName = "";
      this.country = "";
      this.flag = "";
      this.imageId = "";
      this.imageUrl = "";
      this.images = [];
      this.imagesUpload = [];
      this.imagesUpload_BG = [];
      this.$refs.form.reset();
    },
    handleImagesUpdated_BG(images_BG) {
      const uploadedImage = images_BG[0];
      console.log("Uploaded image:", uploadedImage);
    },
    handleImagesUpdated(images) {
      const uploadedImage = images[0];
      console.log("Uploaded image:", uploadedImage);
    },

    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        this.imageId = store.state.imageId;

        const imageId = store.state.imageId;

      this.recitateur.fileUrlDBId = imageId;

        console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    beforeRemove_BG(index, done, fileList) {
      this.showlowding_BG = false;
      this.fakePercentage_BG = 0;
      this.uploadPercentage_BG = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUpload_BG.indexOf(
          fileList[index].path
        );
        this.imageUrl_BG = "";
        this.imageId_BG = "";
        if (index > -1) {
          this.imagesUpload_BG.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUpload.indexOf(
          fileList[index].path
        );
        this.imageUrl = "";
        this.imageId = "";
        if (index > -1) {
          this.imagesUpload.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    convertImagePathToFile(element) {
      const byteString = atob(element.path.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/jpeg" });

      return new File([blob], element.name);
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.RecitateurArray = await getAllRecitateur();
    this.isLoadingTables = false;
    this.RecitateurArray.forEach(async (item) => {
      if (item.fileUrlDBId) {
        await this.loadImage(item);
      }
    });
  },
};
</script>
<style scoped>
.svg-container {
  width: 65px;
  height: 65px;
}
.svg-container svg {
  width: 100%;
  height: 100%;
}
</style>